import { Link } from 'react-router-dom'
import { useCollection } from '../../hooks/useFirestore'
import './AdminEditor.css'

export default function SpellSchoolList() {
  const { data: schools, loading } = useCollection('spellSchools', { orderByField: 'sortOrder' })

  if (loading) {
    return (
      <div className="container">
        <div className="loading-spinner" />
      </div>
    )
  }

  const officialSchools = schools.filter(s => !s.unofficial)
  const unofficialSchools = schools.filter(s => s.unofficial)

  return (
    <div className="container">
      <div className="editor-header">
        <h1>Spell Schools</h1>
        <Link to="/admin/spell-schools/new" className="btn btn-primary">
          + New School
        </Link>
      </div>

      <p className="text-secondary mb-lg">
        Manage spell schools and their icons. Unofficial schools are homebrew additions.
      </p>

      {schools.length === 0 ? (
        <div className="empty-state">
          <p>No spell schools yet.</p>
          <p className="text-secondary">Create your first school or seed the defaults.</p>
          <Link to="/admin/spell-schools/new" className="btn btn-primary mt-md">
            Create School
          </Link>
        </div>
      ) : (
        <>
          {officialSchools.length > 0 && (
            <div className="admin-section">
              <h2>Official Schools</h2>
              <div className="admin-list">
                {officialSchools.map(school => (
                  <Link
                    key={school.id}
                    to={`/admin/spell-schools/${school.id}`}
                    className="admin-list-item"
                  >
                    <div className="school-icon-preview">
                      {school.icon || '✨'}
                    </div>
                    <div className="item-info">
                      <h3>{school.name}</h3>
                      <p className="text-secondary">{school.description || 'No description'}</p>
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          )}

          {unofficialSchools.length > 0 && (
            <div className="admin-section">
              <h2>Unofficial Schools (Homebrew)</h2>
              <div className="admin-list">
                {unofficialSchools.map(school => (
                  <Link
                    key={school.id}
                    to={`/admin/spell-schools/${school.id}`}
                    className="admin-list-item"
                  >
                    <div className="school-icon-preview">
                      {school.icon || '✨'}
                    </div>
                    <div className="item-info">
                      <h3>
                        {school.name}
                        <span className="unofficial-tag">Unofficial</span>
                      </h3>
                      <p className="text-secondary">{school.description || 'No description'}</p>
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          )}
        </>
      )}
    </div>
  )
}
